import { LicenseUser } from '../../models/license-user';
import { assignApplicationIds } from '../../utils/assign-application-ids';
import { formatRegionName } from '../../utils/format-region-name';
import { MILEON_APPLICATION_ID } from '../ams/ams.repository';
import { AccountSummary, FleetUser } from '@tmx/data-access';
import { isEmpty } from '@tmx/core';
import { translate } from '@jsverse/transloco';

function mapFleetResponseToRows(fleetUser: FleetUser, asset: LicenseUser) {
  asset.copilotVersion = fleetUser.appVersion;
  asset.mapDataVersion = fleetUser.formattedDataVersion;

  const mapSets = fleetUser.installedMapRegions;

  const formatedMapSets = mapSets
    ? mapSets.map((val) => {
        const name = formatRegionName(val);
        return translate(`cfs.addEditMapSetModal.region_${name}`);
      })
    : [];
  asset.mapSets = formatedMapSets;

  const osType = fleetUser.osType ?? '';
  asset.osType = osType;

  asset.osVersion = fleetUser.osVersion;
  asset.osLogo = /^(windows|iphone|android)$/i.test(osType)
    ? osType.toLowerCase()
    : '';
  asset.deviceModel = fleetUser.deviceModel;

  asset.address = fleetUser.address ?? null;

  asset.lat = fleetUser.coords?.lat ?? null;
  asset.lon = fleetUser.coords?.lon ?? null;

  asset.lastStoredTimeStamp = fleetUser.lastStoredTimeStamp ?? null;
  if (asset.lastStoredTimeStamp !== null) {
    asset.assignments = [...asset.assignments];
    for (const assignment of asset.assignments) {
      if (assignment.applicationId === MILEON_APPLICATION_ID) {
        continue;
      }
    }
  }
  return asset;
}

export function createLicenseUser(
  user: FleetUser,
  accountSummary: AccountSummary
) {
  const licenseUser = new LicenseUser(user);
  if (!isEmpty(user.assignments)) {
    assignApplicationIds(licenseUser.assignments, accountSummary);
  }
  return mapFleetResponseToRows(user, licenseUser);
}
